import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import PublicNavbar from "../components/PublicNavbar";

const CheckoutCancel = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0B] relative overflow-hidden">
      <PublicNavbar />

      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#EF4444]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#D4AF37]/3 rounded-full blur-3xl"></div>
      </div>

      <main className="relative z-10 pt-32 pb-20 px-6 flex items-center justify-center min-h-[calc(100vh-80px)]">
        <div className="max-w-md w-full text-center">
          <div className="w-20 h-20 rounded-full bg-[#EF4444]/20 flex items-center justify-center mx-auto mb-6">
            <XCircle size={48} className="text-[#EF4444]" />
          </div>
          
          <h1 className="text-3xl font-bold text-[#FAFAFA] mb-4">
            Payment Cancelled
          </h1>
          
          <p className="text-[#A1A1AA] mb-8">
            Your payment was cancelled. No charges were made to your account.
          </p>

          <div className="flex flex-col gap-3">
            <Link to="/booking">
              <Button className="w-full bg-gradient-to-r from-[#D4AF37] to-[#B8952F] text-[#0A0A0B]">
                Try Again
              </Button>
            </Link>
            <Link to="/">
              <Button variant="outline" className="w-full border-[#27272A] text-[#FAFAFA]">
                Return Home
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CheckoutCancel;
